import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useUser from '../../hooks/useUser';
import { ALL_MENU_ENTRIES } from '../../config/menuCatalog';

type Props = {
  children: React.ReactNode;
};

const EXEMPT_PATHS = ['/403', '/me/profile', '/me/security'];

const matchMenuEntry = (pathname: string) => {
  const sorted = [...ALL_MENU_ENTRIES].sort((a, b) => b.path.length - a.path.length);
  return sorted.find((entry) => pathname === entry.path || pathname.startsWith(`${entry.path}/`));
};

const RequireMenuAccess = ({ children }: Props) => {
  const { loading, user } = useUser();
  const location = useLocation();

  const menuEntry = useMemo(() => matchMenuEntry(location.pathname), [location.pathname]);

  if (loading) {
    return <div className="p-4">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (EXEMPT_PATHS.includes(location.pathname)) {
    return <>{children}</>;
  }

  if (!menuEntry) {
    return <>{children}</>;
  }

  const userMenuKeys = Array.isArray((user as any)?.menu_keys) ? (user as any).menu_keys : [];
  const isSuperAdmin = user.role === 'SuperAdmin';
  const hasAccess = isSuperAdmin || userMenuKeys.includes(menuEntry.menuKey);

  if (!hasAccess) {
    return <Navigate to="/403" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};

export default RequireMenuAccess;
